import { pxToRem, responsiveFontSizes } from '../utils/getFontValue';

// ----------------------------------------------------------------------

const FONT_PRIMARY = 'Public Sans, sans-serif'; // Google Font
// const FONT_SECONDARY = 'CircularStd, sans-serif'; // Local Font

const fontWeightRegular = 400;
const fontWeightMedium = 600;
const fontWeightBold = 700;

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular,
  fontWeightMedium,
  fontWeightBold,
  h1: {
    // not used
    fontWeight: fontWeightBold,
    lineHeight: 80 / 64,
    letterSpacing: 2,
    ...responsiveFontSizes({ xs: 40, sm: 52, md: 58, lg: 64 }),
  },
  h2: {
    // not used
    fontWeight: fontWeightBold,
    lineHeight: 64 / 48,
    ...responsiveFontSizes({ xs: 32, sm: 40, md: 44, lg: 48 }),
  },
  h3: {
    fontWeight: fontWeightBold,
    lineHeight: 1.5,
    ...responsiveFontSizes({ xs: 24, sm: 26, md: 30, lg: 30 }),
  },
  h4: {
    fontWeight: fontWeightBold,
    lineHeight: 1.5,
    ...responsiveFontSizes({ xs: 20, sm: 20, md: 24, lg: 24 }),
  },
  h5: {
    fontWeight: fontWeightBold,
    lineHeight: 1.5,
    ...responsiveFontSizes({ xs: 18, sm: 19, md: 20, lg: 20 }),
  },
  h6: {
    fontWeight: fontWeightBold,
    lineHeight: 28 / 18,
    ...responsiveFontSizes({ xs: 17, sm: 18, md: 18, lg: 18 }),
  },
  subtitle1: {
    fontWeight: fontWeightMedium,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
  },
  subtitle2: {
    fontWeight: fontWeightMedium,
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },
  body1: {
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },
  body2: {
    lineHeight: 1.5,
    fontSize: pxToRem(16),
  },
  caption: {
    lineHeight: 1.5,
    fontSize: pxToRem(12),
  },
  overline: {
    fontWeight: fontWeightBold,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    textTransform: 'uppercase',
  },
  button: {
    fontWeight: fontWeightBold,
    lineHeight: 24 / 14,
    fontSize: pxToRem(14),
    textTransform: 'inherit',
  },
} as const;

export default typography;
